'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Domain = {};

exports.__exports = Domain;
